import React, { useState } from 'react';
import { FileImage, ImageSquare } from '@phosphor-icons/react';
import type { GeneratedImage } from '../../../../types/generatedImage';
import { Item } from './Item';
import { ActionMenu } from './ActionMenu';

interface GeneratedImageItemProps {
  image: GeneratedImage;
  onPreview: (image: GeneratedImage) => void;
  onRename: (image: GeneratedImage) => void;
  onDelete: (image: GeneratedImage) => void;
  isNested?: boolean;
}

export const GeneratedImageItem: React.FC<GeneratedImageItemProps> = ({
  image,
  onPreview,
  onRename,
  onDelete,
  isNested = true,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const label = image.name || image.provider;

  return (
    <>
      <Item
        icon={<FileImage size={16} />}
        label={label}
        isNested={isNested}
        onClick={() => onPreview(image)}
        onMenuClick={anchor => setAnchorEl(anchor)}
      />
      <ActionMenu
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        onRename={() => {
          setAnchorEl(null);
          onRename(image);
        }}
        onDelete={() => {
          setAnchorEl(null);
          onDelete(image);
        }}
      />
    </>
  );
};
